export interface DateRangeFilters {
  start_date_after?: string;
  start_date_before?: string;
  end_date_after?: string;
  end_date_before?: string;
}

/** The UI keeps calendar dates; the API compares UTC timestamps inclusively.
 * Match the local dates shown in task cards, including the entire last day. */
export function dateFiltersForApi<T extends DateRangeFilters>(filters: T): T {
  const result = { ...filters };
  for (const key of ['start_date_after', 'start_date_before', 'end_date_after', 'end_date_before'] as const) {
    const value = filters[key];
    if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) continue;
    const date = new Date(`${value}T00:00:00`);
    if (key.endsWith('_before')) {
      date.setDate(date.getDate() + 1);
      date.setMilliseconds(-1);
    }
    result[key] = date.toISOString().replace('.999Z', '.999999Z');
  }
  return result;
}
